import { render, staticRenderFns } from "./sliderModule.vue?vue&type=template&id=ceaa3b92&scoped=true&"
import script from "./sliderModule.vue?vue&type=script&lang=js&"
export * from "./sliderModule.vue?vue&type=script&lang=js&"
import style0 from "./sliderModule.vue?vue&type=style&index=0&id=ceaa3b92&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaa3b92",
  null
  
)

export default component.exports